import axios, {AxiosInstance, AxiosRequestConfig, AxiosResponse} from 'axios';
import { StoreData } from '../hooks/AuthContext';

const createApi = (tokenKey: string): AxiosInstance => {
  const token = localStorage.getItem(tokenKey);
  if (!token) throw new Error(`Token not found for key "${tokenKey}"`);

  return axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json'
    }
  });
};

export const ApiFidegg = {
  get: async <T = any>(url: string, config?: AxiosRequestConfig): Promise<AxiosResponse<T>> => {
    const api = createApi('@fidegg:token');
    return await api.get<T>(url, config);
  },

  post: async <T = any>(url: string, data: any, config?: AxiosRequestConfig): Promise<AxiosResponse<T>> => {
    const api = createApi('@fidegg:token');
    return await api.post<T>(url, data, config);
  },

  put: async <T = any>(url: string, data: any, config?: AxiosRequestConfig): Promise<AxiosResponse<T>> => {
    const api = createApi('@fidegg:token');
    return await api.put<T>(url, data, config);
  },

  delete: async <T = any>(url: string, config?: AxiosRequestConfig): Promise<AxiosResponse<T>> => {
    const api = createApi('@fidegg:token');
    return await api.delete<T>(url, config);
  },

  monitor: {
    getStores: async (): Promise<StoreData[]> => {
      const api = createApi('@fidegg:tokenMonitor');
      const response = await api.get<StoreData[]>('/storesadmin');
      return response.data ?? [];
    }
  }
};